<template>
  <v-stepper class="elevation-0">
    <v-stepper-header>
      <fragment
        v-for="(p, pIndex) in pages"
        :key="pIndex"
      >
        <v-divider v-if="pIndex" />
        <v-stepper-step
          class="text-capitalize"
          :complete="pageID > pIndex - 1"
          :editable="pageID === pIndex"
          :step="pIndex + 1"
        >
          {{ p }}
        </v-stepper-step>
      </fragment>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
import { computed } from '@vue/composition-api'
import { pages } from '@/constants'

export default {
  props: {
    page: {
      type: String,
      default: 'intro',
      validator: value => pages.indexOf(value) !== -1
    }
  },
  setup: (props) => {
    const pageID = computed(() => pages.indexOf(props.page))

    return {
      pages,
      pageID
    }
  }
}
</script>
